import APIService from './APIService';

export default {
  getDadosGeograficos(codigosMunicipiosIbge) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().post('/municipios/get-dados-geograficos', JSON.stringify({ codigos_municipios_ibge: codigosMunicipiosIbge }))
        .then(response => resolve(response.data))
        .catch(() => reject(false));
    });
  },
  getAllMunicipios() {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get('municipios/get-all-municipios')
        .then(response => resolve(response.data))
        .catch(() => reject(false));
    });
  },
  getMunicipiosByCompany(company_id = null) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`municipios/get-municipios-by-company?company_id=${company_id}`)
        .then(response => resolve(response.data))
        .catch(() => reject(false));
    });
  },
  getMunicipiosByRegional(regional) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`municipios/get-municipios-by-regional?regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(() => reject(false));
    });
  },
  getRegionais() {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`municipios/get-regionais`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  downloadXlsx(titulo, municipios) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().post('municipios/download-xlsx', { titulo, municipios }, { responseType: 'blob' })
        .then(response => resolve(response.data))
        .catch(() => reject(false));
    });
  },
}